module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/hairstyle_02@2x-2e61d8256e70558c2401f028e68cc2e4.webp";